import ajax from '../http/ajax'

/**
 * 获取标签筛选信息
 * @param {*} params 参数
 * @return 略
 */
export const getDiscountServiceTags = params => {
    return ajax.get('getDiscountServiceTags', params)
}

/**
 * 获取特惠服务列表
 * @param {*} params 参数
 * @return 略
 */
export const getDiscountServiceList = params => {
    return ajax.get('getDiscountServiceList', params)
}
